/* unplugin-vue-components disabled */

export default {
  props: {
    tracked: {type: Boolean, default: false},
    saving: {type: Boolean, default: false},
  },
  emits: ['add'],
  data(){
    return {
      save_complete: this.tracked,
    }
  },
  watch: {
    async saving(_, was_saving){
      if (this.tracked && was_saving) {
        await $utils.timers.wait(200)
        this.save_complete = true
      }
    }
  },
}
